
import { create } from 'zustand';
import { CoachesState, CoachOperations } from './types';
import { createCoachOperations } from './coachOperations';

export const useCoachesSupabaseStore = create<CoachesState & CoachOperations>((set, get) => ({
  coaches: [],
  selectedCoach: null,
  isLoading: false,
  error: null,
  ...createCoachOperations(set, get),
}));
